(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/video-player/assets/javascripts/content-loader.js') >= 0) return;  svs.modules.push('/components/components/video-player/assets/javascripts/content-loader.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
  var solidTangoUrl;

  function loadVideo(options, callback) {
    if (options && options.type === 'solidtango') {
      var model = {
        src: "https://".concat(solidTangoUrl, "/widgets/embed/").concat(options.videoId).concat(options.api ? '?api=true&autoFillScreen=0' : '?autoFillScreen=0'),
        heightPercent: options.height && options.width ? options.height / options.width * 100 : undefined,
        videoId: options.videoId
      };
      callback(null, model);
    } else {
      callback('Unsupported media source type');
    }
  }

  if (isServer) {
    solidTangoUrl = require('trinidad-core').core.tpnsconfig.solidtango.host;
    module.exports = {
      loadVideo: loadVideo
    };
  } else {
    solidTangoUrl = svs.core.config.data.svsconfig.solidTango || 'svspeltur.solidtango.com';
    svs.components.video_player.contentLoader = {
      loadVideo: loadVideo
    };
  }
})();
 })(window);